import { Pipe, PipeTransform } from '@angular/core';
import {DataAttribute} from '@app/views/admin/application-settings/models/data-attribute.model';

@Pipe({
    name: 'filterAllowedAttributes'
})
export class FilterAllowedAttributesPipe implements PipeTransform {
    transform(attributesList: DataAttribute[], selectedAttributesList: string[], currentPropertyName: string, restrictedAttributesList: string[] = []): any {
        let restrictedAttributesObj = {};
        restrictedAttributesObj = this.filterAttributesList(selectedAttributesList, currentPropertyName, restrictedAttributesObj);
        restrictedAttributesObj = this.filterAttributesList(restrictedAttributesList, currentPropertyName, restrictedAttributesObj);

        return attributesList.filter((attribute: DataAttribute) => !restrictedAttributesObj[attribute.propertyName]);
    }

    private filterAttributesList(filtredAttributesList: string[], currentPropertyName: string, restrictedAttributesObj: {}) {
        if (filtredAttributesList) {
            filtredAttributesList.forEach((propertyName: string) => {
                if (propertyName && (propertyName !== currentPropertyName)) {
                    restrictedAttributesObj[propertyName] = propertyName;
                }
            });
        }
        return restrictedAttributesObj;
    }
}
